let srcSetSupported;

function isSrcSetSupported() {
    if (typeof srcSetSupported === 'undefined') {
        srcSetSupported = 'srcset' in document.createElement('img');
    }

    return srcSetSupported;
}

export { isSrcSetSupported };
